import { useMediaQuery } from "react-responsive";
import type { Config } from "tailwindcss";
import resolveConfig from "tailwindcss/resolveConfig";

import config from "../../tailwind.config";

export enum BreakpointEnum {
  "3XL" = "3xl",
  "2XL" = "2xl",
  XL = "xl",
  LG = "lg",
  MD = "md",
  SM = "sm",
  XS = "xs",
}

const fullConfig = resolveConfig(config as Config);

/**
 * Don't use this in rendering logic on any page server rendered, or you'll have a bad time with react hydration errors
 */

//
const breakpoints: Record<BreakpointEnum, number> = fullConfig.theme.screens as any;

export function useBreakpoints() {
  const is3xl = useMediaQuery({
    query: `(min-width: ${breakpoints[BreakpointEnum["3XL"]]})`,
  });
  const is2xl = useMediaQuery({
    query: `(min-width: ${breakpoints[BreakpointEnum["2XL"]]})`,
  });
  const isXl = useMediaQuery({
    query: `(min-width: ${breakpoints[BreakpointEnum.XL]})`,
  });
  const isLg = useMediaQuery({
    query: `(min-width: ${breakpoints[BreakpointEnum.LG]})`,
  });
  const isMd = useMediaQuery({
    query: `(min-width: ${breakpoints[BreakpointEnum.MD]})`,
  });
  const isSm = useMediaQuery({
    query: `(min-width: ${breakpoints[BreakpointEnum.SM]})`,
  });
  const isXs = useMediaQuery({
    query: `(min-width: ${breakpoints[BreakpointEnum.XS]})`,
  });

  return {
    is3xl,
    is2xl,
    isXl,
    isLg,
    isMd,
    isSm,
    isXs,
  };
}
